import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './index.styl';

const CommunitiesList = ({ title, counter, children }) => (
  <div styleName="list-wrapper">
    <If condition={!!title}>
      <h3 styleName="title">
        {title} ({counter})
      </h3>
    </If>
    <ul styleName="list">{children}</ul>
  </div>
);

CommunitiesList.propTypes = {
  title: PropTypes.string,
  counter: PropTypes.number,
  children: PropTypes.node.isRequired,
};

CommunitiesList.defaultProps = {
  title: '',
  counter: null,
};

export default CSSModules(CommunitiesList, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Components/CommunitiesList/index.jsx